import { UI } from '../lib/ui.js'
export class ListGroup {
    constructor(){
        const ui = window.ui ? window.ui : new UI
        this.wrapper = ui.element('ul',{class:'list-group'})
        return this.wrapper
    }
    add(item) {
        if(Array.isArray(item))
            return this.addGroup(item)
    }
    listItem(item){
        return ui.element('li',{class : 'list-group-item'},item)
    }
    addGroup(items) {
        items.forEach(item => {
            this.wrapper.append(listItem(item))
        })
        return this.wrapper
    }
}